import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { NotificationManager } from "react-notifications";
import Autocomplete from '@mui/material/Autocomplete';
import updateConfigurationResponse from "../../apis/globalConfiguration/updateGlobalConfiguration";
import DataTable from "../../components/DataTable/DataTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";

const styleSx = {
  table: {
    minWidth: 650,
  },
  bodyForSupport: {
    padding: "0px 30px!important",
  },
  buttonForSupport: {
    justifyContent: "flex-end !important",
    padding: "25px 30px 30px!important",
  },
  title: {
    padding: "16px 30px!important",
  },
  label: {
    display: "inline-block",
    fontSize: "17px",
    color: "#04093F",
    fontFamily: "Segoe-Regular",
    fontStyle: "normal",
    marginBottom: "10px !important"
  },
  bodyForShare: {
    padding: "0px 30px!important",
  },
};

const DefaultOrganization = ({ data, org, setisDataUpdaed, isDataLoaded }) => {

  const [openEditModal, setOpenEditModal] = useState(false);
  const [dataForEdit, setDataForEdit] = useState({});
  const [selectedOrg, setSelectedOrg] = useState({});
  const [atvBtn, setAtvBtn] = useState(false);
   const history = useNavigate();


  const closeModal = () => {
    setOpenEditModal(false);
  };
  const openModal = (list) => {
    setOpenEditModal(true);
    setDataForEdit(list);
    setSelectedOrg(list.recruitmentpartner);
  };
  const updateHandler = async () => {
    setAtvBtn(true);
    const data = {
      id: dataForEdit.id ? dataForEdit.id : "",
      code: dataForEdit.code ? dataForEdit.code : "",
      name: dataForEdit.name ? dataForEdit.name : "",
      value: selectedOrg?.id ? selectedOrg.id : "",
      updatedBy: null,
    };
    const payload = {
      code: dataForEdit.code,
      data: data,
    };
    try {
      await updateConfigurationResponse(payload);
      NotificationManager.success(
        `${dataForEdit.name} updated`,
        "Success",
        10000
      );
      setisDataUpdaed(true);
      setOpenEditModal(false);
      setAtvBtn(false);
    } catch (error) {
      console.log(error);
      setAtvBtn(false);
    }
  };

  const orgChange = async (event, value) => {
    setSelectedOrg(value);
  };

  let columns = [
    {
      accessorKey: "name",
      header: "Name",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "recruitmentpartner.name",
      header: "Recruitment Organization",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <>
          <button
            className='editBtn_manageSpoc'
            onClick={() => openModal(row.original)}
          >
            Edit
          </button>
        </>
      ),
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
    },
  ]

   const goToDashboard = () => {
        history("/admin-home");
    };

  return (
    <>
      <div className="communityHeader_manageUser ">
        <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
          <Tooltip title="Go Back to Dashboard" placement="bottom">
            <ArrowBackIcon sx={{ fontSize: 20 }} />
          </Tooltip>
        </div>
        <div className="communityTitle">Default Recruitment Organizations</div>
      </div>
      <DataTable
        data={data}
        columns={columns}
        isLoading={!isDataLoaded}
      />

      <Dialog
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="admindailog_title_modal_global_config"
        >
          {dataForEdit.name}
        </DialogTitle>

        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="dropdown_width_outer mt_12">
            <div className="select customized-select default-org">
              <label sx={styleSx.label} htmlFor="country">
                Recruitment Organization*
              </label>
              <Autocomplete
                id="combo-box-demo"
                className="mt_11"
                options={org}
                autoHighlight
                value={selectedOrg}
                getOptionLabel={(option) =>
                  selectedOrg?.name
                    ? option?.name
                    : option?.name
                }
                onChange={orgChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    required
                    placeholder="Select Recruitment Organization"
                  />
                )}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport}>
          <button
            type="button"
            className="btn5 btn-skill cp"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button variant="outlined" className="btn5 btn_primary cp" disabled={atvBtn} onClick={updateHandler}>
            <div className="btn_loader">
              Submit
              &nbsp;
              {atvBtn &&
                <div >
                  <CircularProgress size={15} />
                </div>
              }
            </div>
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DefaultOrganization;
